export default {
	dialogPaper: {
		overflowY: 'hidden',
	},
	dialogActionsRoot: {
		width: '100%',
	},
};
